import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import PackageSummary from 'components/PackageSummary';
import CheckoutForm from 'components/forms/CheckoutForm';
import { bindActionCreators } from 'redux';
import * as checkoutDataActions from 'actions/checkoutDataActions';
import { Elements } from 'react-stripe-elements';
import { List } from 'immutable';
import { getFormValues, change } from 'redux-form';
import * as countriesActions from 'actions/countriesActions';
import * as publishersActions from 'actions/publishersActions';
import * as currentUserActions from 'actions/currentUserActions';
import { trackPageView } from 'lib/eventTracking'

class SecureCheckoutPage extends Component {
  static propTypes = {
    className: PropTypes.string,
    currency: PropTypes.string,
    currentPrice: PropTypes.number,
    packageType: PropTypes.string,
    formErrors: PropTypes.object,
    countries: PropTypes.object,
    formIsLoading: PropTypes.bool,
    eventQuantity: PropTypes.number,
    currentUser: PropTypes.object,
    currentEvent: PropTypes.object,
    availableCurrencies: PropTypes.object.isRequired,
    isLoadingPrice: PropTypes.bool.isRequired,
    availablePublishersCount: PropTypes.number.isRequired,
    isUpgrading: PropTypes.bool,
    invoice_id: PropTypes.number,
    packageId: PropTypes.number,
    email_campaign_id: PropTypes.number,
    is_email_campaign_enterprise: PropTypes.bool,
    email_campaign_audience: PropTypes.string,
    email_campaign_location: PropTypes.string,
    email_campaign_broadcast_time: PropTypes.string,
    publisher_id: PropTypes.number,
    market: PropTypes.string.isRequired,
    marketPublicName: PropTypes.string.isRequired,
    packageTemplateSet: PropTypes.object.isRequired,
    history: PropTypes.object,
    snapSell: PropTypes.bool.isRequired,
    formValues: PropTypes.object,
    fetchCountries: PropTypes.func.isRequired,
    updatePackagePrice: PropTypes.func.isRequired,
    changePackageCurrency: PropTypes.func.isRequired,
    changePackageType: PropTypes.func.isRequired,
    changePackageEventQuantity: PropTypes.func.isRequired,
    createOrder: PropTypes.func.isRequired,
    createSimpleOrder: PropTypes.func.isRequired,
    fetchPublishers: PropTypes.func.isRequired,
    checkEmail: PropTypes.func.isRequired,
    signInUser: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.checkoutForm = null;
  }

  state = {
    password: '',
  };

  componentDidMount() {
    trackPageView('Package Checkout');

    if (this.props.currentPrice == null || this.props.currentPrice == 0) {
      this.props.updatePackagePrice();
    }

    if (this.props.availablePublishersCount < 1) {
      this.props.fetchPublishers();
    }

  }

  onSubmit(data) {
    this.props.createOrder(
      data,
      this.checkoutForm.context.stripe,
      this.checkoutForm.findElement('card'),
      this.props.history,
      this.props.snapSell
    );
  }

  submitForm() {
    if (!this.props.currentUser.get('isLoggedIn', false)) {
      if (this.props.currentUser.get('passwordRequired')) {
        this.props.signInUser(
          this.props.formValues.email,
          this.state.password,
          () => this.submitForm()
        );

        return;
      }
    }

    if (this.props.packageType !== 'free' && this.props.packageType !== 'free_publisher') {
      this.checkoutForm.getWrappedInstance().submit();
    } else {
      if (this.props.snapSell) {
        this.props.history.push({ pathname: '/basics' });
      } else {
        this.props.createSimpleOrder('free');
      }
    }
  }

  onFree = () => {
    this.props.changePackageType('free');
    this.props.history.push({ pathname: '/basics' });
  };

  render() {
    const {
      currency,
      packageType,
      packageVolume,
      currentPrice,
      formErrors,
      countries,
      changePackageCurrency,
      changePackageType,
      formIsLoading,
      packageTemplateSet,
      eventQuantity,
      changePackageEventQuantity,
      currentUser,
      currentEvent,
      availableCurrencies,
      isLoadingPrice,
      availablePublishersCount,
      isUpgrading,
      invoice_id,
      email_campaign_id,
      is_email_campaign_enterprise,
      email_campaign_audience,
      email_campaign_location,
      email_campaign_broadcast_time,
      publisher_id,
      market,
      marketPublicName,
      packageId,
      className,
      snapSell,
      formValues,
      partnerExports,
      featuringPublisher,
      isPrepay,
    } = this.props;

    let globalError = null;
    if (formErrors.get('global')) {
      globalError = <Alert color="danger">{formErrors.get('global')}</Alert>;
    }
    const accountAddress = currentUser && currentUser.getIn(['data', 'account_address']);
    const address = accountAddress && accountAddress.toObject();
    if (address) {
      Object.keys(address).forEach(key => (address[key] == null) && delete address[key]);
      if (address.country && address.country_code ) address.country = { name: address.country, iso_alpha2: address.country_code };
    }

    const isFree = packageType === 'free' || packageType === 'free_publisher'

    const formInitialValues = {
      business_name: currentUser.get('data') !== null ?
        (currentUser.getIn(['data','account_name']) || currentEvent.getIn(['data', 'organiser_name'])) :
        null,
      payment_method: 'card',
      ...address,
    };

    const newSnapSellUser = snapSell && currentUser && !currentUser.get('isLoggedIn', false);
    const publishersCount = snapSell || currentEvent && availablePublishersCount > 0 ? availablePublishersCount : "unlimited";

    return (
      <div className={`row mt-3 ${className}`}>
        {newSnapSellUser && <div className="col-12 mb-4">
          <Card>
            <h3 className="text-center my-2">
              We’ve created you an account using your email {this.props.formValues.email},
              please continue to checkout.
            </h3>
          </Card>
        </div>}
        <div className="col-12 col-lg-8">
          <Card>
            <div className="card-header">
              <h4>Checkout</h4>
            </div>
            <CardBody>
              {globalError}
              {packageType == 'free' && <Alert color="primary">
                Promote your event for free to 1+ event listing sites & access our Event Promotions Platform 'EPP' where you can still upgrade to unlimited coverage.
              </Alert>}
              {packageType == 'free_publisher' && <Alert color="primary">
                Go Free and start building your new events calendar by adding a theme, choosing data sources to populate your calendar, and invite team members.
              </Alert>}
              {!isFree && <Elements>
                <CheckoutForm
                  onSubmit={this.onSubmit.bind(this)}
                  formErrors={formErrors}
                  availableCountries={countries}
                  isLoading={formIsLoading}
                  packageTemplateSet={packageTemplateSet}
                  ref={(form) => { this.checkoutForm = form; }}
                  initialValues={formInitialValues}
                  isRebooking={packageId !== null}
                />
              </Elements>}
            </CardBody>
          </Card>
        </div>
        <div className="col mt-2 mt-md-0">
          <PackageSummary
            currency={currency}
            packageType={packageType}
            packageVolume={packageVolume}
            currentPrice={currentPrice}
            onSubmit={this.submitForm.bind(this)}
            onCurrencyChange={changePackageCurrency.bind(this)}
            onTypeChange={changePackageType.bind(this)}
            submitButtonText="Pay Securely Now"
            isLoading={formIsLoading}
            isLoadingPrice={isLoadingPrice}
            packageTemplateSet={packageTemplateSet}
            eventQuantity={eventQuantity}
            onQuantityChange={changePackageEventQuantity}
            availableCurrencies={packageId ? List([currency]) : availableCurrencies}
            publishersCount={publishersCount}
            isUpgrading={isUpgrading}
            invoice_id={invoice_id}
            email_campaign_id={email_campaign_id}
            is_email_campaign_enterprise={is_email_campaign_enterprise}
            email_campaign_location={email_campaign_location}
            email_campaign_audience={email_campaign_audience}
            email_campaign_broadcast_time={email_campaign_broadcast_time}
            publisher_id={publisher_id}
            market={marketPublicName}
            snapSell={snapSell}
            partnerExports={partnerExports}
            featuringPublisher={featuringPublisher}
            isPrepay={isPrepay}
          />
          {snapSell && <div className="text-center mt-2">
            <a href='#' onClick={this.onFree}>Not ready to pay yet? Try our free service</a>
          </div>}
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  currency: state.checkoutData.get('currency'),
  currentPrice: state.checkoutData.get('currentPrice'),
  packageType: state.checkoutData.get('package_type'),
  isPrepay: state.checkoutData.get('prepay'),
  packageVolume: state.checkoutData.get('package_volume'),
  eventQuantity: state.checkoutData.get('event_quantity'),
  formErrors: state.checkoutData.getIn(['form', 'errors']),
  formIsLoading: state.checkoutData.getIn(['form', 'isLoading'], false),
  countries: state.countries.get('list'),
  packageTemplateSet: state.checkoutData.get('package_template_set'),
  currentUser: state.currentUser,
  currentEvent: state.checkoutData.get('current_event'),
  availableCurrencies: state.checkoutData.get('available_currencies'),
  isLoadingPrice: state.checkoutData.get('isPriceLoading'),
  availablePublishersCount: state.publishers.get('totalCount'),
  isUpgrading: state.checkoutData.get('is_upgrading'),
  invoice_id: state.checkoutData.get('invoice_id'),
  email_campaign_id: state.checkoutData.get('email_campaign_id'),
  is_email_campaign_enterprise: state.checkoutData.get('is_email_campaign_enterprise'),
  email_campaign_location: state.checkoutData.get('email_campaign_location'),
  email_campaign_audience: state.checkoutData.get('email_campaign_audience'),
  email_campaign_broadcast_time: state.checkoutData.get('email_campaign_broadcast_time'),
  publisher_id: state.checkoutData.get('publisher_id'),
  packageId: state.checkoutData.get('package_id'),
  market: state.checkoutData.get('market'),
  marketPublicName: state.checkoutData.get('market_public_name'),
  config: state.config,
  snapSellPackageId: state.checkoutData.get('snap_sell_package_id'),
  formValues: getFormValues('eventSubmission')(state),
  partnerExports: state.checkoutData.get('partner_exports'),
  featuringPublisher: state.checkoutData.get('featuring_publisher'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(checkoutDataActions, dispatch),
  ...bindActionCreators(countriesActions, dispatch),
  ...bindActionCreators(publishersActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecureCheckoutPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SecureCheckoutPage.jsx